export enum LinguagemEnum {
  Portugues = "pt",
  Ingles = "en",
  Espanhol = "es",
}
